import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Lemonade Shoes' "NINI - Chic Mule"
// (p_fyejmrsyhx), read from GET /api/product-reviews/product/p_fyejmrsyhx —
// verbatim comment, real reviewer, real rating, real publish date.
export const review_ls3: FaireReviewEntity = {
  token: "review_ls3",
  type: "review",
  brandName: "Lemonade Shoes",
  brandToken: "b_mz3xxxsvnf",
  productToken: "p_fyejmrsyhx",
  reviewType: "product",
  reviewerName: "Shaneka G.",
  reviewerLocation: "Minneapolis, MN",
  stars: 5,
  reviewText: "Quality is great. Item came as pictured.",
  reviewDate: "May 19, 2026",
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:55:00.000Z",
    importedBy: "entity-db-cli",
  },
};
